var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLivletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 250,
    viewBox: "0 0 251 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 25,
    width: 200,
    height: 200,
    rx: 100,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1182 164.91C95.577 164.91 98.3809 162.064 98.3809 158.552C98.3809 155.04 95.577 152.193 92.1182 152.193C88.6594 152.193 85.8555 155.04 85.8555 158.552C85.8555 162.064 88.6594 164.91 92.1182 164.91Z",
    fill: "#00B74F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1178 134.596C97.4295 134.596 101.736 130.224 101.736 124.831C101.736 119.438 97.4295 115.066 92.1178 115.066C86.806 115.066 82.5 119.438 82.5 124.831C82.5 130.224 86.806 134.596 92.1178 134.596Z",
    fill: "#00B74F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.174 90.8784C135.174 96.215 130.925 100.53 125.557 100.53C120.189 100.53 115.939 96.215 115.939 90.8784C115.939 85.4282 120.189 81 125.557 81C130.925 81 135.174 85.4282 135.174 90.8784Z",
    fill: "#00B74F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.883 164.91C162.342 164.91 165.146 162.064 165.146 158.552C165.146 155.04 162.342 152.193 158.883 152.193C155.425 152.193 152.621 155.04 152.621 158.552C152.621 162.064 155.425 164.91 158.883 164.91Z",
    fill: "#00B74F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.882 134.596C164.194 134.596 168.5 130.224 168.5 124.831C168.5 119.438 164.194 115.066 158.882 115.066C153.57 115.066 149.264 119.438 149.264 124.831C149.264 130.224 153.57 134.596 158.882 134.596Z",
    fill: "#00B74F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.558 139.135C133.341 139.135 139.65 132.729 139.65 124.828C139.65 116.927 133.341 110.521 125.558 110.521C117.776 110.521 111.467 116.927 111.467 124.828C111.467 132.729 117.776 139.135 125.558 139.135Z",
    fill: "#00B74F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.174 158.665C135.174 164.002 130.925 168.317 125.557 168.317C120.189 168.317 115.939 164.002 115.939 158.665C115.939 153.215 120.189 148.787 125.557 148.787C130.925 148.787 135.174 153.215 135.174 158.665Z",
    fill: "#00B74F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: 0.5,
    y: 0,
    width: 250,
    height: 250,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.682353 0 0 0 0 0.682353 0 0 0 0 0.752941 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivletIcon);
export default __webpack_public_path__ + "static/media/livlet-icon.242f36c1.svg";
export { ForwardRef as ReactComponent };